import log from './log';

const baseUrl = '/api';
const _ = require('../services/comparators');

const getAuthHeaders = () => {
    const authToken = localStorage.getItem('token');
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + authToken,
    }
}

const getHeaders = () => {
  return {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
  }
}

const getAPIHeaders = (apiKey) => {
  return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': apiKey
  }
}

const toJson = (result) => {
    return result.then(data => data.json()).then((data) => data)
}

const Fetcher = {
    signInUser: (name, email) => {
        return toJson(fetch(`${baseUrl}/users/signin`, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({
              name: name,
              email: email
            })}))
    },
    exchangeFirebaseSession: (idToken) => {
        return toJson(fetch(`${baseUrl}/users/firebase-session`, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ idToken })
        }))
    },
    completeMcpOauth: (externalAuthId) => {
      return toJson(fetch(`${baseUrl}/users/mcp/oauth/complete`, {
        method: 'post',
        headers: getAuthHeaders(),
        body: JSON.stringify({ externalAuthId })
      }))
    },
    refreshToken: (name, email) => {
        return toJson(fetch(`${baseUrl}/users/signin`, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({
              name: name,
              email: email
            })}))
    },
    getBlogPost: (url) =>{
        return toJson(fetch(`${baseUrl}${url}`))
    },
    getBlogPosts: () => {
        return toJson(fetch(`${baseUrl}/blog`))
    },
    getMetals: () => {
      return toJson(fetch(`${baseUrl}/metals`))
    },
    getCurrencies: () => {
      return toJson(fetch(`${baseUrl}/currencies`))
    },
    getStaticPrice: (symbol, curr) => {
      return toJson(fetch(`${baseUrl}/static/${symbol}/${curr}`))
    },
    updateBillingDetails: (cardToken, price, promo) => {
        return toJson(fetch(`${baseUrl}/users/customer`, {
          method: 'post',
          headers: getAuthHeaders(),
          body: JSON.stringify({
            sourceToken: cardToken.id,
            price: price,
            promo: promo
          })}))
    },
    unsubscribeCustomer: () => {
      return toJson(fetch(`${baseUrl}/users/unsubscribe`, {
        method: 'post',
        headers: getAuthHeaders()}))
    },
    revokeApiKey: () => {
      return toJson(fetch(`${baseUrl}/users/revoke-api-key`, {
        method: 'post',
        headers: getAuthHeaders()
      }))
    },
    removeUser: () => {
      return toJson(fetch(`${baseUrl}/users/remove`, {
        method: 'post',
        headers: getAuthHeaders()
      }))
    },
    sendSupportRequest: (topic, title, message) => {
      return toJson(fetch(`${baseUrl}/users/support`, {
        method: 'post',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          topic: topic,
          title: title,
          message: message
        })
      }))
    },
    sendEnterprisePlanRequest: (request) => {
      return toJson(fetch(`${baseUrl}/users/enterprise-plan-request`, {
        method: 'post',
        headers: getAuthHeaders(),
        body: JSON.stringify(request)
      }))
    },
    redirectToCustomerPortal: (selection = {}) => {
      log.traceTag('redirectToCustomerPortal')
      return toJson(fetch(`${baseUrl}/users/customer-portal`,{
        method: 'post',
        headers: getAuthHeaders(),
        body: JSON.stringify(selection)
      }))
    },
    callStatusAPI: (apiKey) => {
      return toJson(fetch(`${baseUrl}/status`, {
        method: 'get',
        headers: getAPIHeaders(apiKey)}))
    },
    callPriceAPI: (apiKey, symbol, curr, date, options = {}) => {
      const params = new URLSearchParams({
        melt_price: String(options.meltPrice !== false),
        currency_info: String(options.currencyInfo !== false),
        purity: String(options.purity === true)
      });
      return toJson(fetch(`${baseUrl}/price/${symbol}/${curr}/${date}?${params.toString()}`, {
        method: 'get',
        headers: getAPIHeaders(apiKey)}))
    },
    callRatesAPI: (apiKey, curr1, curr2) => {
      return toJson(fetch(`${baseUrl}/rates/${curr1}/${curr2}`, {
        method: 'get',
        headers: getAPIHeaders(apiKey)}))
    },
    callLbmaAPI: (apiKey, metal, date) => {
      return toJson(fetch(`${baseUrl}/lbma/${metal}/${date}`, {
        method: 'get',
        headers: getAPIHeaders(apiKey)}))
    },
    callMetalHistoryAPI: (apiKey, metal, currency, from, to) => {
      const params = new URLSearchParams({ from, to });
      return toJson(fetch(`${baseUrl}/history/${metal}/${currency}?${params.toString()}`, {
        method: 'get',
        headers: getAPIHeaders(apiKey)}))
    },
    callRequestsStatAPI: (apiKey) => {
      return toJson(fetch(`${baseUrl}/stat`, {
      method: 'get',
      headers: getAPIHeaders(apiKey)}))
    },
    getWebSocketAllowance: () => {
      return toJson(fetch(`${baseUrl}/ws/allowance`, {
        method: 'get',
        headers: getAuthHeaders()
      }))
    },
    requestWebSocketToken: (wsApiKey) => {
      return toJson(fetch(`${baseUrl}/ws/token`, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-ws-api-key': wsApiKey
        }
      }))
    },
    rotateWebSocketApiKey: () => {
      return toJson(fetch(`${baseUrl}/ws/allowance/rotate-key`, {
        method: 'post',
        headers: getAuthHeaders()
      }))
    },
      // STRIPE

    getPlans: (country) => {
      return toJson(fetch(`${baseUrl}/plans/${country}`, {
        headers: getHeaders()
      }))
    },

    createCheckoutSession: (plan) => {
      return toJson(fetch(`${baseUrl}/users/create-checkout-session`,{
        method: 'post',
        headers: getAuthHeaders(),
        body: JSON.stringify(plan)
      }))
    }
}

export default Fetcher;
